import { Property } from '../types/Property';

export const properties: Property[] = [
  {
    id: '1',
    name: 'Horseshoe Inn and Conference Center',
    description: 'Comfortable Accommodations: Horseshoe Inn and Conference Center in Kimberley offers family rooms with private bathrooms, air-conditioning, and garden views. Each room includes a ...',
    location: '101 Memorial Road, 8301 Kimberley, South Africa',
    price: 44.09,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/122358480.jpg?k=11690a1931e64ff074aff581923edce6b6341116494abe3a6fce7fae2b615225&o='
  },
  {
    id: '2',
    name: 'Ivanka\'s Self-Catering Flat',
    description: 'Comfortable Living: Ivanka\'s Self-Catering Flat in Kimberley offers a one-bedroom apartment with a terrace and free WiFi. The ground-floor unit features a living room, dining are...',
    location: '4 Ayliff Road, 8301 Kimberley, South Africa',
    price: 47.11,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/557462953.jpg?k=6a0068323e9baaf54f9b2c2e0c15a87068672c2aa6c1fb0a9897d318f07d571c&o='
  },
  {
    id: '3',
    name: 'Villa D este',
    description: 'Elegant Accommodation: Villa D este in Kimberley offers a bed and breakfast experience with a beautiful garden, terrace, and a year-round outdoor swimming pool. Guests enjoy free...',
    location: '4 Mac Dougall Street, 8301 Kimberley, South Africa',
    price: 17.52,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/619358816.jpg?k=5900087516d615aa7dbaea672a6b12a41aeb4506d37d0eb2c3f87cfb39eff402&o='
  },
  {
    id: '4',
    name: 'Hub Accomodation',
    description: 'Comfortable Accommodation: Hub Accommodation in Kimberley offers a one-bedroom apartment with a living room. The property features a private pool, sun terrace, and garden. Guests...',
    location: '8 Hugo Street, 8301 Kimberley, South Africa',
    price: 43.36,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/548343051.jpg?k=de64e0cf49679f75534b767ce84cf534a6b86eeaf6cf5e5fdce6727d6e4729a1&o='
  },
  {
    id: '5',
    name: 'Kimberly Luxury Suites',
    description: 'Comfortable Accommodation: Kimberly Luxury Suites in Kimberley offers a holiday home with three bedrooms and two bathrooms. The property features a spacious living room, family r...',
    location: 'Madoc Road, 8301 Kimberley, South Africa',
    price: 66.31,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/556253688.jpg?k=081e97953d6311db08ec627e692a0fc1675e89d45d37049c12af3c3fa60c40b5&o='
  },
  {
    id: '6',
    name: 'The Dusty Vine',
    description: 'You might be eligible for a Genius discount at The Dusty Vine. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book da...',
    location: '17 Tobie Muller Street, 9970 Philippolis, South Africa',
    price: 32.51,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/511422293.jpg?k=a2eaa4adc4d3db28576741e406175f2b4f335d7dc28be315eb930e91e761f586&o='
  },
  {
    id: '7',
    name: 'Kalahari Lodge Kimberley',
    description: 'You might be eligible for a Genius discount at Kalahari Lodge Kimberley. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject ...',
    location: 'Cnr of Memorial Road and Landbou Weg, 8301 Kimberley, South Africa',
    price: 84.67,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/187579526.jpg?k=f3fb19b34d9fe46bd773923e7fcbbb9a4eef9388eb2e23f0973b1b09ca92d4f8&o='
  },
  {
    id: '8',
    name: 'Langberg Guest Farm',
    description: 'You might be eligible for a Genius discount at Langberg Guest Farm. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to bo...',
    location: 'N12 Memorial Road, 8700 Kimberley, South Africa',
    price: 94.84,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/334119036.jpg?k=1fa334f80e4a7c77c02a03c449179749c974078ca9bb36361cc15ddcf0b10c01&o='
  },
  {
    id: '9',
    name: 'The WhiteHouse FarmHouse Overnight Stay',
    description: 'Comfortable Accommodation: The WhiteHouse FarmHouse Overnight Stay in Ritchie offers a holiday home with one bedroom and two bathrooms. Guests enjoy a lounge, family rooms, and l...',
    location: '2nd Ave, 8701 Ritchie, South Africa',
    price: 49.44,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/677056795.jpg?k=f8dc7542b6d604d21c9a1742cbe19c8d2412eedaadf1d020b42c20cba37f4177&o='
  },
  {
    id: '10',
    name: 'Maloba Lodge - Private Game Reserve',
    description: 'Comfortable Accommodations: Maloba Lodge - Private Game Reserve in Kameelpan offers spacious rooms with air-conditioning, private bathrooms, and garden or mountain views. Each ro...',
    location: '6395+R7 Speranza, 8301 Kameelpan, South Africa',
    price: 47.64,
    amenities: [],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/766074191.jpg?k=e1dabe3d207c49fa411bf0a9865d140488a365a1d4a1fdce77fe92356a41813c&o='
  },
  {
    id: '11',
    name: 'Dopper Joris Bruidswa Adam se Uitspanning',
    description: 'Elegant Accommodation: Dopper Joris Bruidswa Adam se Uitspanning in Orania offers a luxury tent with a swimming pool and a beautiful garden. Guests can relax by the outdoor firep...',
    location: 'R369 Dopper Joris bruidswa, 8752 Orania, South Africa',
    price: 43.0,
    amenities: [],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/643243816.jpg?k=c03d5b40146baae06c6f4fdcfbed75561da0c398368e9d5feb5e4bc10904fba5&o='
  },
  {
    id: '12',
    name: 'Goshen Guest Farm',
    description: 'Historic Setting: Goshen Guest Farm in Edenburg offers a spacious farm stay housed in a historic building. Guests enjoy a year-round outdoor swimming pool, sun terrace, and lush ...',
    location: 'N1 offramp Edenburg, 9908 Edenburg, South Africa',
    price: 86.12,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/499466070.jpg?k=4481d0e5eec78bfe01abd1d07d3510c32e7ebbd62d8a1245fcbda0a7c0271754&o='
  },
  {
    id: '13',
    name: 'Green Acres Farm Cottage',
    description: 'Comfortable Living: Green Acres Farm Cottage in Ritchie offers a two-bedroom, two-bathroom apartment with a fully equipped kitchen and garden views. Free WiFi and free on-site pr...',
    location: '1st Street Green Acres Farm, 8701 Ritchie, South Africa',
    price: 68.8,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/631436359.jpg?k=d41280d7e8abe57bc75eb9ba22c026cb633760cfa87fbaa975531cd89da112ac&o='
  },
  {
    id: '14',
    name: 'La Ford',
    description: 'Elegant Accommodation: La Ford in Hopetown Langford offers a comfortable apartment with a sun terrace, water sports facilities, and a lush garden. Guests enjoy free WiFi, ensurin...',
    location: 'Hopetown Langford, 8750 Hopetown, South Africa',
    price: 20.41,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/559399030.jpg?k=25d1a3dc0e677f4b0909400b52e4784e2fc1f4d284f0c9a8a4e6b1a32b24ec4e&o='
  },
  {
    id: '15',
    name: 'Oleander Guest House',
    description: 'You might be eligible for a Genius discount at Oleander Guest House. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to b...',
    location: '28 Carrington Avenue, Belgravia, 8301 Kimberley, South Africa',
    price: 60.75,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/134127966.jpg?k=24dcaab7655949592fae47f362dfbdb0b91cb98066eaf72760926aba44ed936a&o='
  },
  {
    id: '16',
    name: 'The Nook B&B',
    description: 'Elegant Accommodation: The Nook B&B in Kimberley offers a serene garden and a seasonal outdoor swimming pool. Guests enjoy free WiFi throughout the property, ensuring connectivit...',
    location: '65 Lawson Street Labram, 8301 Kimberley, South Africa',
    price: 30.03,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/81475138.jpg?k=778418a82bce150fd1b725a6e329cb36b8e9831a206aadb8ac6cedb2dbb9a04b&o='
  },
  {
    id: '17',
    name: 'Repa Boutique Lodge Self-Catering Units',
    description: 'Comfortable Accommodation: Repa Boutique Lodge Self-Catering Units in Kimberley offers 4-star comfort with family rooms and free WiFi. Guests can relax in the garden or on the te...',
    location: '79 Aviva Road, 8301 Kimberley, South Africa',
    price: 67.79,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/559222279.jpg?k=71ccbc34ddf594247d29c5bcb4e477a5857d4e96963b4e72d5e7b737020f168c&o='
  },
  {
    id: '18',
    name: '70 on Aviva Bed and Go',
    description: 'Comfortable Accommodation: 70 on Aviva Bed and Go in Kimberley offers spacious family rooms with air-conditioning, private bathrooms, and tiled floors. Each room includes a wardr...',
    location: '70 Aviva Road, 8301 Kimberley, South Africa',
    price: 38.62,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/424232513.jpg?k=61ae9ae43e2b30915aa4fb4954735c3dd59b56114175f6a1aebd61b90e6e8182&o='
  },
  {
    id: '19',
    name: 'Knersvlakte Ossewaens Adam se Uitspanning',
    description: 'Elegant Accommodation: Knersvlakte Ossewaens Adam se Uitspanning in Orania offers a luxury tent with a garden and a year-round outdoor swimming pool. Guests enjoy private check-i...',
    location: 'Kambro Ekopark, Orania, 8752 Orania, South Africa',
    price: 38.39,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/596377570.jpg?k=c70dc2d35ec2f16474acb21d7f8ac79412a08c0d72339ddbea610b5f436c5ab4&o='
  },
  {
    id: '20',
    name: 'Blomwaens Adam se Uitspanning',
    description: 'Elegant Accommodation: Blomwaens Adam se Uitspanning in Orania offers a luxury tent with a swimming pool and a beautiful garden. Guests can relax in the outdoor dining area and e...',
    location: 'Kambro Ekopark, 8752 Orania, South Africa',
    price: 52.83,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/749737571.jpg?k=9ca0c140288bd0d35412ee24f322635e0bcb41601a2b41cfd2f06dd146db52ba&o='
  },
  {
    id: '21',
    name: 'Groot Gryses Adam Se Uitspanning',
    description: 'You might be eligible for a Genius discount at Groot Gryses Adam Se Uitspanning. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are ...',
    location: 'Kambro Ekopark, Orania, 8752 Orania, South Africa',
    price: 35.6,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/595334172.jpg?k=7e0e81ee1514659d8c2915ad031955ecd740ba371bf1fa900e3db0c68cce9a46&o='
  },
  {
    id: '22',
    name: 'The Solomon Guest House',
    description: 'Comfortable Accommodation: The Solomon Guest House in Kimberley offers recently renovated family rooms with private bathrooms. Each room includes air-conditioning, a work desk, a...',
    location: '1 Solomon Street, 8301 Kimberley, South Africa',
    price: 63.64,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/431031826.jpg?k=e491943d4b269bbfc8f9fb971def20040857fd3ff7a3077c4697da1fd923377b&o='
  },
  {
    id: '23',
    name: '57 on Milner',
    description: 'You might be eligible for a Genius discount at 57 on Milner. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book date...',
    location: '57a Milner St, 8301 Kimberley, South Africa',
    price: 19.53,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/651728197.jpg?k=8c146ae34dd41197a11c2cfb990a4c2db5c06dda16343097c115bad13ddbc522&o='
  },
  {
    id: '24',
    name: 'Royal Apartments Kimberley',
    description: 'Comfortable Accommodation: Royal Apartments Kimberley in Kimberley offers apartment-style accommodation with free WiFi, air-conditioning, and a kitchenette. Each unit features a ...',
    location: '2 Jacobus Smit Avenue, 8301 Kimberley, South Africa',
    price: 56.28,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/306833484.jpg?k=862784b85ece57e513451775386d5f11ca86499f30cc175ba1f670d94e04efd9&o='
  },
  {
    id: '25',
    name: 'Ideal Location Kimberley 4',
    description: 'Comfortable Living Space: Ideal Location Kimberley 4 offers a one-bedroom apartment in Kimberley. The property features a fully equipped kitchen, air-conditioning, sofa bed, and ...',
    location: '29 Welgevonden Street, 8301 Kimberley, South Africa',
    price: 61.71,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/609987122.jpg?k=df8623bc9f0b9d0b058e0bb68174e026333a15964fdbcae2aee75dc4f3c9aad4&o='
  },
  {
    id: '26',
    name: 'Prime Location Kimberley 3',
    description: 'Comfortable Accommodation: Prime Location Kimberley 3 offers a spacious apartment in Kimberley, South Africa. The property features two bedrooms, three bathrooms, and a comfortab...',
    location: '29 Welgevonden Street, 8301 Kimberley, South Africa',
    price: 53.62,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/609980349.jpg?k=6cd42369db656030a29dc99b4b0f5892bf7a6c2e3eed2f277ed885af6abf26f4&o='
  },
  {
    id: '27',
    name: 'Biki Plek 2',
    description: 'Comfortable Living Space: Biki Plek 2 in Kimberley offers a ground-floor apartment with one bedroom and one bathroom. The property features a garden, a year-round outdoor swimmin...',
    location: '3 Solomon Street, 8301 Kimberley, South Africa',
    price: 98.19,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/415419531.jpg?k=405912295dc1c41a027da894febb940038dac481c449df65ab1a4c41f32a9496&o='
  },
  {
    id: '28',
    name: 'Villa Palma',
    description: 'You might be eligible for a Genius discount at Villa Palma. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book dates...',
    location: '44 Carrington Way, 8301 Kimberley, South Africa',
    price: 54.7,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/449907489.jpg?k=1052a2566df5d6c63193f1aead113d88e06f5b55b5c9031611d2e63dad15ced4&o='
  },
  {
    id: '29',
    name: 'Krulkop',
    description: 'Comfortable Accommodation: Krulkop in Kimberley offers ground-floor units with air-conditioning, private bathrooms, and kitchenettes. Each room includes a dining area, work desk,...',
    location: '7 Solomon Street Unite 1, 8301 Kimberley, South Africa',
    price: 72.96,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/404335187.jpg?k=914e2c66a16844d1cf8aba987b07b48577d8067c3127f85608c753adfb9a3590&o='
  },
  {
    id: '30',
    name: 'J\'s Haven Self-Catering',
    description: 'Comfortable Accommodation: J\'s Haven Self-Catering in Kimberley offers a spacious apartment with free WiFi, air-conditioning, and a fully equipped kitchenette. The property featu...',
    location: '2 Solomon Street, 8301 Kimberley, South Africa',
    price: 16.69,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/745650768.jpg?k=73b82ce44831c5c9b29afa152d2324a02957e4788efb64a70ac22e3e01982f06&o='
  },
  {
    id: '31',
    name: 'SUN1 Kimberley',
    description: 'Comfortable Accommodations: SUN1 Kimberley in Kimberley offers comfortable rooms with air-conditioning, private bathrooms, city views, walk-in showers, work desks, and TVs. Each ...',
    location: 'Cnr. Memorial and Welgevonden Avenue, 8301 Kimberley, South Africa',
    price: 45.16,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/330877900.jpg?k=08727cf73937801d7c1dcbaffabe7da85a4273fe1bf059de6818953db12442c0&o='
  },
  {
    id: '32',
    name: 'Sonskip Oornagverblyf',
    description: 'Comfortable Accommodation: Sonskip Oornagverblyf in Orania offers family rooms with garden views. Each ground-floor unit includes a terrace, outdoor furniture, and a sofa bed. Fr...',
    location: '207 Robynlaan, 8752 Orania, South Africa',
    price: 32.02,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/728769111.jpg?k=6278f4241f68548526ab07ffacb80637a2ab944302d386b9de4fe31088298dc6&o='
  },
  {
    id: '33',
    name: 'Kairos Guesthouse Orania',
    description: 'You might be eligible for a Genius discount at Kairos Guesthouse Orania. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject ...',
    location: '69 Witolien street, Karoosig, 8752 Orania, South Africa',
    price: 20.81,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/633899520.jpg?k=49b557143491198725eb15c59672f8ae8e89678f811f80f4f21b042c8a43d7be&o='
  },
  {
    id: '34',
    name: 'Willem Sternbergwa Adam se Uitspanning',
    description: 'You might be eligible for a Genius discount at Willem Sternbergwa Adam se Uitspanning. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this propert...',
    location: 'Kambro Ekopark, Orania, 8752 Orania, South Africa',
    price: 62.73,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/595326498.jpg?k=9cd9615d5d2373fe1cb52175ff68584db5c8a48789e63c37dfd943bb40efcd23&o='
  },
  {
    id: '35',
    name: '213 Magers',
    description: 'Comfortable Accommodation: 213 Magers in Riet River offers a homestay experience with a beautiful garden. Guests enjoy private bathrooms with garden views, refrigerators, free to...',
    location: '213 The Highlanders, Magersfontein Memorial Golf Estate, Modderrivier, 8300 Ritchie, South Africa',
    price: 97.27,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/610487302.jpg?k=f241822f8fa90ec17093aa405f4d072e5a7d2875efc522c6d9068495496e110f&o='
  },
  {
    id: '36',
    name: 'OppiRantje Orania',
    description: 'You might be eligible for a Genius discount at OppiRantje Orania. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book...',
    location: '51 Olienhoutrylaan, 8752 Orania, South Africa',
    price: 98.78,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/548555159.jpg?k=927f2cabe605b85bcb16c1007dd7d4241e6b0996ae12fafe05e452fbe0de1e82&o='
  },
  {
    id: '37',
    name: 'Vacation Home in Orania',
    description: 'You might be eligible for a Genius discount at Vacation Home in Orania. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject ...',
    location: '112 Tolbosweg, 8752 Orania, South Africa',
    price: 76.91,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/720517650.jpg?k=a2fe5d46f5055d68360a91e508b49acd3333b79cc01323c05c74585a256c2517&o='
  },
  {
    id: '38',
    name: 'Fisheagle Hut in Orania',
    description: 'Comfortable Accommodation: Fisheagle Hut in Orania offers a welcoming inn experience with free on-site private parking. Each room features a private bathroom with a bath and show...',
    location: 'Orania, 8752 Orania, South Africa',
    price: 76.19,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/721296920.jpg?k=d9c1d764dc4400a8ce5d10042989e8f65a53b7b93d56434a623838ad3dbbfc54&o='
  },
  {
    id: '39',
    name: 'Kleine Kaap - Selfsorg',
    description: 'Comfortable Accommodation: Kleine Kaap - Selfsorg in Orania offers a two-bedroom apartment with two bathrooms and a spacious living room. The property features family rooms and a...',
    location: 'Olienhoutrylaan, 8752 Orania, South Africa',
    price: 28.95,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/326606319.jpg?k=450eb264c50eb3f7dc8cb21dcc5d82b92790a7eada616c5a4da62813d686deba&o='
  },
  {
    id: '40',
    name: 'Bed In Die Boord',
    description: 'Comfortable Accommodation: Bed In Die Boord in Orania offers a guest house experience with private bathrooms, air-conditioning, and free on-site private parking. Each room includ...',
    location: 'Oewerpark, 8752 Orania, South Africa',
    price: 80.3,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/669521956.jpg?k=7bb0f9d8a32ddf9b983b86fd86c20d3d7c569d63e4ca0fa53b54913727246897&o='
  },
  {
    id: '41',
    name: 'Monte Crous Hotel, Restaurant and Venue',
    description: 'You might be eligible for a Genius discount at Monte Crous Hotel, Restaurant and Venue. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this proper...',
    location: 'Madeliefie Street, 8771 Vanderkloof, South Africa',
    price: 79.79,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/609261257.jpg?k=05497abb340df5c81c486306e1ca04da23498a7c99d745a8416710dc548ef374&o='
  },
  {
    id: '42',
    name: 'Rhino Manor',
    description: 'You might be eligible for a Genius discount at Rhino Manor. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book dates...',
    location: '64 Patrysblom Street, 8771 Vanderkloof, South Africa',
    price: 84.59,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/539926810.jpg?k=818f0fd618a657ebaf24366b055fc048718b00e393fe49920c6a3887bb4f283f&o='
  },
  {
    id: '43',
    name: 'CasaMere',
    description: 'You might be eligible for a Genius discount at CasaMere. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book dates, s...',
    location: '113 Gansie Street, 8771 Vanderkloof, South Africa',
    price: 32.81,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/578307519.jpg?k=2710aaccceba88272fd8133932b6bd9beac6985fadad37d49aaf6372f4f20455&o='
  },
  {
    id: '44',
    name: 'Von Loë Huizen',
    description: 'Comfortable Accommodation: Von Loë Huizen in Fauresmith offers family rooms with private bathrooms, kitchenettes, and parquet floors. Each room includes a dining area, work desk,...',
    location: '16 East Burger Street, 9978 Fauresmith, South Africa',
    price: 59.69,
    amenities: [],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/718328752.jpg?k=fa5a417b6d997413dfbce170bfe321525a5ca96754eb04d9829654af6552b842&o='
  },
  {
    id: '45',
    name: 'The Nouveaux de Parts -Main House',
    description: 'Comfortable Living: The Nouveaux de Parts -Main House in Jacobsdal offers a one-bedroom apartment with a garden and free WiFi. Guests can relax in the outdoor fireplace, hot tub,...',
    location: '17 Church Street, 8710 Jacobsdal, South Africa',
    price: 99.17,
    amenities: [],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/719542646.jpg?k=cfab04b09c77202791d2b491a6d8c578fdedb334f5766cd856abb5667840ddc6&o='
  },
  {
    id: '46',
    name: 'Route 66',
    description: 'Comfortable Living Space: Route 66 in Jacobsdal offers a one-bedroom apartment with a garden view. The property includes a fully equipped kitchen and a modern bathroom. Essentia...',
    location: '17 Church street, 8701 Jacobsdal, South Africa',
    price: 78.41,
    amenities: [],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/763049757.jpg?k=041e98d431c940dae243f0099704792bb30401ce98f7ccc065f0ebd11342a534&o='
  },
  {
    id: '47',
    name: 'Ruitersrust',
    description: 'Comfortable Accommodations: Ruitersrust in Fauresmith offers family rooms with private bathrooms, parquet floors, and modern amenities. Each room includes a washing machine, refr...',
    location: '12 Van Riebeeck Street, 9978 Fauresmith, South Africa',
    price: 79.35,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/724929575.jpg?k=5caa48b28d333bcc35f667d6cae7c28db4737307e1bfe9e0d3db9e4dd72bb83a&o='
  },
  {
    id: '48',
    name: 'S Residence',
    description: 'Elegant Accommodation: S Residence in Kimberley offers a guest house experience with a beautiful garden and a year-round outdoor swimming pool. Free WiFi is available throughout ...',
    location: '12 Haberfeld Street floor, 8301 Kimberley, South Africa',
    price: 81.28,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/764481298.jpg?k=03309d402b751cb9b30c955deb9955503036b4489423ae8dc9179932197976c3&o='
  },
  {
    id: '49',
    name: 'Lofdal Guesthouse',
    description: 'Comfortable Accommodation: Lofdal Guesthouse in Kimberley offers recently renovated family rooms with private bathrooms, garden views, and modern amenities. Each room includes ai...',
    location: '5 John Schoeman St Townhouse, 8301 Kimberley, South Africa',
    price: 28.33,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/753025470.jpg?k=e40c0cc48ef6b8848021ec7487c6581223736d558a5c98fef8275dbb07be480f&o='
  },
  {
    id: '50',
    name: '51 Carrington Flat',
    description: 'Comfortable Living: 51 Carrington Flat in Kimberley offers a one-bedroom apartment with a living room and a private pool. The kitchenette and fully equipped kitchen provide all n...',
    location: '51 Carrington Way,Klisserville,, 8301 Kimberley, South Africa',
    price: 18.88,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/656742574.jpg?k=96d7366da3ec1867966d089b57bbbb1b22a5bcb1f9f2c2d350b0944edb754590&o='
  },
  {
    id: '51',
    name: '51 Carrington Way',
    description: 'You might be eligible for a Genius discount at 51 Carrington Way. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book...',
    location: '51 Carrington Way, 8301 Kimberley, South Africa',
    price: 24.78,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/577176382.jpg?k=7b7ae0529eb47208837b4d317523445d34cfc13f9a40ba3b3d7ad2ee2482d573&o='
  },
  {
    id: '52',
    name: '28 La Rochelle',
    description: 'You might be eligible for a Genius discount at 28 La Rochelle. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book da...',
    location: '28 La Rochelle Avenue Royldene, 8301 Kimberley, South Africa',
    price: 23.31,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/288600319.jpg?k=b1afd0a7ab26eabe315e7145cff22ea332a618cebc4c0b2d1cc0db6102ab6d1d&o='
  },
  {
    id: '53',
    name: 'Boschendal Guesthouse',
    description: 'Comfortable Accommodations: Boschendal Guesthouse in Kimberley offers family rooms with air-conditioning, private bathrooms, and garden views. Each room includes a work desk, TV,...',
    location: '10 Boschendal Avenue, 8301 Kimberley, South Africa',
    price: 38.39,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/641852871.jpg?k=cee833a993e6251fdf350c512d1b409ff5f00cdcf92a3af7634f753755ba38bb&o='
  },
  {
    id: '54',
    name: 'Beloved Lodge',
    description: 'You might be eligible for a Genius discount at Beloved Lodge. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to book dat...',
    location: '65 Main Street, 8301 Kimberley, South Africa',
    price: 41.49,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/496073503.jpg?k=364f78f95e133abe132f8675e9b2d9c366a13f8f8383686339adabba8d4ad226&o='
  },
  {
    id: '55',
    name: 'The Honeycomb',
    description: 'Comfortable Living Space: The Honeycomb in Kimberley offers a ground-floor apartment with a terrace and balcony. Guests enjoy garden views and a private outdoor dining area. Mod...',
    location: '14 John Schoeman Street, 8301 Kimberley, South Africa',
    price: 41.09,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/316211267.jpg?k=360801cbd62c328ec9c2d8a8c721b31c73095ec4f11e6212808d2c6f6ba4fddc&o='
  },
  {
    id: '56',
    name: 'Comfy Home',
    description: 'Comfortable Accommodation: Comfy Home in Kimberley offers a homestay experience with a garden and a year-round outdoor swimming pool. Free WiFi is available throughout the proper...',
    location: '52 Brockman Place, Beaconsfield, 8301 Kimberley, South Africa',
    price: 90.37,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/636163082.jpg?k=7af4c412dd975041f4bc5af51c38dc38850b59146ba1d0d76f513ea14eed6a1a&o='
  },
  {
    id: '57',
    name: 'Comfy Home',
    description: 'Comfortable Living: Comfy Home in Kimberley offers a holiday home with one bedroom and one bathroom. Guests enjoy a garden and free WiFi, ensuring a relaxing and connected stay. ...',
    location: '52 Brockman Place, 8301 Kimberley, South Africa',
    price: 63.11,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/629176919.jpg?k=ad09df1cd9a906567096ccbd94fdd32ded779e2835a936cfb4268032255b42a9&o='
  },
  {
    id: '58',
    name: 'Gifty Surprize Airbnb',
    description: 'You might be eligible for a Genius discount at Gifty Surprize Airbnb. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to ...',
    location: '70 Mac Dougall Street, 8301 Kimberley, South Africa',
    price: 86.08,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/534391670.jpg?k=e4f1868544421386275ca9da30e0627f2a3a6f64fe9e338a622cdda2c6f1c2a9&o='
  },
  {
    id: '59',
    name: 'Kimberley Anne Hotel',
    description: 'You might be eligible for a Genius discount at Kimberley Anne Hotel. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to b...',
    location: '60 Mac Dougall Street, 8301 Kimberley, South Africa',
    price: 21.23,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/61749549.jpg?k=cc74ed5a050e03dbb9bf7115d355815ae0d08eb71b1bf502b13ec781a11bc265&o='
  },
  {
    id: '60',
    name: 'O\'Meara Overnight Rooms',
    description: 'Comfortable Accommodation: O\'Meara Overnight Rooms in Kimberley offers a bed and breakfast experience with private bathrooms, air-conditioning, and free WiFi. Each room features ...',
    location: '5 O Meara Street 5, 8301 Kimberley, South Africa',
    price: 24.53,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/733344316.jpg?k=84e905cebc9384d2eabae5e32df4ba4f425dba07a286e00ff9dc6dc268d60de6&o='
  },
  {
    id: '61',
    name: '4 Aces Outfitters Lodge',
    description: 'Comfortable Accommodations: 4 Aces Outfitters Lodge in Kimberley offers family rooms with private bathrooms, air-conditioning, and garden views. Each room includes a work desk, w...',
    location: 'Farm Spitskop, 8301 Kimberley, South Africa',
    price: 25.75,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/604090245.jpg?k=66e6091fb762dcb58a6e993242809e6dc7fbd0a75f142eb080a78b18808f568c&o='
  },
  {
    id: '62',
    name: 'Pro Plants Accommodation',
    description: 'Comfortable Accommodation: Pro Plants Accommodation in Kimberley offers aparthotel-style accommodation with family rooms. Each unit features air-conditioning, a private bathroom,...',
    location: 'Portion 103 of farm Bultfontein, N12 Cape Town Road, 8301 Kimberley, South Africa',
    price: 69.88,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/457040843.jpg?k=a5736b6dc78c60ca9a5f0980c95fbdcbcf2000d6aa1699368fb5b4669fdbe4f9&o='
  },
  {
    id: '63',
    name: 'En Route Guest House',
    description: 'Elegant Accommodation: En Route Guest House in Trompsburg offers a swimming pool with stunning views, a lush garden, and free WiFi. Guests can relax in the outdoor seating area o...',
    location: 'Vlakfontein Farm Free State po box 175, 9913 Trompsburg, South Africa',
    price: 37.73,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/194285765.jpg?k=83c8e8cc6fd2e43d877163b607b94f0b568f91061a417b0f28c60cdbd452e298&o='
  },
  {
    id: '64',
    name: 'home 2 home',
    description: 'Comfortable Accommodation: home 2 home in Kimberley offers a guest house with a garden, terrace, bar, and free WiFi. Guests can relax in the hot tub and enjoy garden views. Mode...',
    location: '15 Jakaranda Street, 8301 Kimberley, South Africa',
    price: 74.75,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/430543494.jpg?k=c294c1cd5ce9b23e16dae09d78d1abb088009f2ebc3a71223fc43de4e70f1ecb&o='
  },
  {
    id: '65',
    name: 'Onyx Villa',
    description: 'Comfortable Accommodation: Onyx Villa in Kimberley offers family rooms with private bathrooms. Each room includes air-conditioning, a balcony, bath, free toiletries, shower, TV, ...',
    location: '9 Onyx Crescent, 8301 Kimberley, South Africa',
    price: 33.88,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/485457889.jpg?k=21764fd1483f25fee78ebd08a009028a8bf3e43077cd4b230752155769cb1b4a&o='
  },
  {
    id: '66',
    name: 'Motheo Adventure Farm Resort and Spa',
    description: 'Accommodation Features: Motheo Adventure Farm Resort and Spa in Kimberley offers family rooms with private bathrooms, balconies, and garden or pool views. Each room includes air-...',
    location: 'Motheo Adventure Farm, R64, 15 km from Kimberley, 8301 Kimberley, South Africa',
    price: 61.2,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/588629559.jpg?k=9f05b918068390d691d34f9c9aebc02694242736e7482bc94634844e676ef268&o='
  },
  {
    id: '67',
    name: 'On 47a',
    description: 'Comfortable Accommodation: On 47a in Kimberley offers a ground-floor apartment with a private entrance. The property features tiled floors and a fully equipped kitchenette with a...',
    location: '47A Barkly Road, West End , 8301 Kimberley, South Africa',
    price: 60.14,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/599738918.jpg?k=4fa16a0951017a9875683e0091ea6b4fc982c4e16c5ecc1ff2ec9c9caf4ce71a&o='
  },
  {
    id: '68',
    name: 'Josephs Guest Home Kimberley',
    description: 'Elegant Accommodation: Josephs Guest Home Kimberley in Kimberley offers an adults-only guest house with a beautiful garden and a year-round outdoor swimming pool. Guests enjoy fr...',
    location: '34 Hull street, De Beers. Kimberley 8301, 8301 Kimberley, South Africa',
    price: 70.17,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/484660773.jpg?k=862f6da403b59bdca98880c4282082c03d9c63f0abd31c7f1aae245655d9ec09&o='
  },
  {
    id: '69',
    name: 'Tucker House B&B',
    description: 'Comfortable Accommodation: Tucker House B&B in Kimberley offers air-conditioned rooms with private bathrooms, baths, and free WiFi. Each room includes a tea and coffee maker, hai...',
    location: '22 Tucker Street, 8300 Kimberley, South Africa',
    price: 42.98,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/681478658.jpg?k=0eecb6dc6430421433414abef0e7b267e3de091ccf94b7ae7b99c5f7df6cd559&o='
  },
  {
    id: '70',
    name: 'New Rush Guest House',
    description: 'You might be eligible for a Genius discount at New Rush Guest House. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject to b...',
    location: 'Tucker street 2 Big Hole Complex, 8301 Kimberley, South Africa',
    price: 31.35,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location', 'Free WiFi'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/107565258.jpg?k=14025261a6a3e8ef0bb558d21d489fe0b385f16f606bc3145d8cb708a7abc2cd&o='
  },
  {
    id: '71',
    name: 'Carstens Garden Cottages',
    description: 'You might be eligible for a Genius discount at Carstens Garden Cottages. To check if a Genius discount is available for your selected dates sign in. Genius discounts at this property are subject ...',
    location: '25 Schmidtsdrift Road, 8301 Kimberley, South Africa',
    price: 25.05,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/599250611.jpg?k=fbdfc44d464ca85550904e74b443291cfdf11cfea970cdbf61c0bdb60ff8ba2a&o='
  },
  {
    id: '72',
    name: 'Tucker House B&B',
    description: 'Comfortable Accommodations: Tucker House B&B in Kimberley offers air-conditioned rooms with private bathrooms, kitchen facilities, and garden views. Each room includes a washing ...',
    location: 'Tucker Street, 22, 8301 Kimberley, South Africa',
    price: 88.19,
    amenities: ['Staff', 'Facilities', 'Cleanliness', 'Comfort', 'Value for money', 'Location'],
    imageUrl: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/681435344.jpg?k=579db8cc19aba8990e13989cbbd5322b6c073a8034d64a82689bb2db4e220d03&o='
  }
];
